module.exports = "#footer {\r\n    position:fixed;\r\n    bottom:0;\r\n}"